import React from 'react';
import { TextInput, required, useGetOne, useTranslate } from 'react-admin';

const requiredForKiosk = [required('resources.chargers.validation.bayNumberRequiredForKiosk')];

interface BayNumberInputProps {
    siteId?: string;
    variant: 'create' | 'edit';
}

export const BayNumberInput: React.FC<BayNumberInputProps> = ({ siteId, variant }) => {
    const translate = useTranslate();
    const { data: site } = useGetOne('sites', { id: siteId }, { enabled: Boolean(siteId) });
    const kioskAccessEnabled = Boolean((site as any)?.kioskAccessEnabled);

    return (
        <TextInput
            source="bayNumber"
            sx={{ flex: 1 }}
            validate={kioskAccessEnabled ? requiredForKiosk : undefined}
            isRequired={kioskAccessEnabled}
            helperText={translate(
                kioskAccessEnabled
                    ? `resources.chargers.${variant}.bayNumberRequiredHelperText`
                    : `resources.chargers.${variant}.bayNumberHelperText`
            )}
        />
    );
};
